import { handleApi } from "./common";

export const fetch_fund_details = async (Api, isins, token) => {
  try {
    const res = await Api.get(`/api/funds/advance/report/text/v2?isins=${isins}`, {}, {}, token);
    const data = handleApi(res);
    return data;
  } catch (err) {
    throw err;
  }
};

export const fetch_fund_graph = async (Api, isin) => {
  try {
    const res = await Api.get(`/api/funds/advance/report/graph/v2?isins=${isin}`);
    const data = handleApi(res);
    return data;
  } catch (err) {
    throw err;
  }
};